const API_BASE = String(
    process.env.REACT_APP_AUTH_API ||
    process.env.REACT_APP_RV_API_BASE ||
    "https://api.racevision.info"
).replace(/\/$/, "");

async function apiGet(path) {
    const res = await fetch(`${API_BASE}${path}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const msg = (typeof data?.detail === "string" && data.detail) || `HTTP ${res.status} (${path})`;
        throw new Error(msg);
    }
    return data;
}

export async function fetchPublicSeasons(seriesKey = "gt3x") {
    return apiGet(`/api/public/series/${encodeURIComponent(seriesKey)}/seasons`);
}

export async function fetchPublicRaces(seriesKey = "gt3x", seasonKey = "active") {
    return apiGet(`/api/public/series/${encodeURIComponent(seriesKey)}/seasons/${encodeURIComponent(seasonKey)}/races`);
}

export async function fetchPublicResults({
    seriesKey = "gt3x",
    seasonKey = "active",
    raceTag,
    raceId,
    sessionType = "RACE",
    classKey = "",
}) {
    const qs = new URLSearchParams();
    if (raceTag) qs.set("race_tag", raceTag);
    if (raceId) qs.set("race_id", String(Number(raceId)));
    if (sessionType) qs.set("session_type", sessionType);
    if (classKey) qs.set("class_key", classKey);
    return apiGet(
        `/api/public/series/${encodeURIComponent(seriesKey)}/seasons/${encodeURIComponent(seasonKey)}/results?${qs.toString()}`,
    );
}

export async function fetchPublicStandings({
    seriesKey = "gt3x",
    seasonKey = "active",
    scopeType = "DRIVER",
    classKey = "",
}) {
    const qs = new URLSearchParams();
    qs.set("scope_type", scopeType);
    if (classKey) qs.set("class_key", classKey);
    return apiGet(
        `/api/public/series/${encodeURIComponent(seriesKey)}/seasons/${encodeURIComponent(seasonKey)}/standings?${qs.toString()}`,
    );
}

export async function fetchPublicStreamers({
    seriesKey = "gt3x",
    seasonKey = "active",
} = {}) {
    const qs = new URLSearchParams();
    if (seasonKey) qs.set("season_key", seasonKey);
    return apiGet(`/api/public/series/${encodeURIComponent(seriesKey)}/streamers?${qs.toString()}`);
}
